export const questions = [
    {
        id: 0,
        value1: 'Makes lists',
        value2: 'Relies on memory'
    },
    {
        id: 1,
        value1: 'Skeptical',
        value2: 'Wants to believe'
    },
    {
        id: 2,
        value1: 'Bored by time alone',
        value2: 'Needs time alone'
    },
    {
        id: 3,
        value1: 'Accepts things as they are',
        value2: 'Unsatisfied with the way things are'
    },
    {
        id: 4,
        value1: 'Keeps a clean room',
        value2: 'Just puts stuff wherever'
    },
    {
        id: 5,
        value1: 'Thinks "robotic" is an insult',
        value2: 'Strives to have a mechanical mind'
    }
    ,
    {
        id: 6,
        value1: 'Energetic',
        value2: 'Mellow'
    },
    {
        id: 7,
        value1: 'Prefers to take multiple choice test',
        value2: 'Prefers essay answers'
    },
    {
        id: 8,
        value1: 'Chaotic',
        value2: 'Organized'
    },
    {
        id: 9,
        value1: 'Easily hurt',
        value2: 'Thick-skinned'
    },
    {
        id: 10,
        value1: 'Works best in groups',
        value2: 'Works best alone'
    },
    {
        id: 11,
        value1: 'Focused on the present',
        value2: 'Focused on the future'
    },
    {
        id: 12,
        value1: 'Plans far ahead',
        value2: 'Plans at the last minute'
    },
    {
        id: 13,
        value1: `Wants people's respect`,
        value2: `Wants people's love`
    },
    {
        id: 14,
        value1: 'Gets worn out by parties',
        value2: 'Gets fired up by parties'
    },
    {
        id: 15,
        value1: 'Fits in',
        value2: 'Stands out'
    },
    {
        id: 16,
        value1: 'Keeps options open',
        value2: 'Commits'
    },
    {
        id: 17,
        value1: 'Wants to be good at fixing things',
        value2: 'Wants to be good at fixing people'
    },
    {
        id: 18,
        value1: 'Talks more',
        value2: 'Listens more'
    },
    {
        id: 19,
        value1: 'When describing an event, will tell people what happened',
        value2: 'When describing an event, will tell people what it meant'
    },
    {
        id: 20,
        value1: 'Gets work done right away',
        value2: 'Procrastinates'
    },
    {
        id: 21,
        value1: 'Follows the heart',
        value2: 'Follows the head'
    },
    {
        id: 22,
        value1: 'Stays at home',
        value2: 'Goes out on the town'
    },
    {
        id: 23,
        value1: 'Wants the big picture',
        value2: 'Wants the details'
    },
    {
        id: 24,
        value1: 'Improvises',
        value2: 'Prepares'
    },
    {
        id: 25,
        value1: 'Bases morality on justice',
        value2: 'Bases morality on compassion'
    },
    {
        id: 26,
        value1: 'Finds it difficult to yell very loudly',
        value2: 'Yelling to others when they are far away comes naturally'
    },
    {
        id: 27,
        value1: 'Theoretical',
        value2: 'Empirical'
    },
    {
        id: 28,
        value1: 'Works hard',
        value2: 'Plays hard'
    },
    {
        id: 29,
        value1: 'Uncomfortable with emotions',
        value2: 'Values emotions'
    },
    {
        id: 30,
        value1: 'Likes to perform in front of other people',
        value2: 'Avoids public speaking'
    },
    {
        id: 31,
        value1: 'Likes to know "who?", "what?", and "when?"',
        value2: 'Likes to know "why?"'
    }
];